"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* tslint:disable */
var node = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__id",
    "args": null,
    "storageKey": null
  },
      v3 = [v0, v2];
  return {
    "kind": "Fragment",
    "name": "Overview_artist",
    "type": "Artist",
    "metadata": null,
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "partner_category",
      "type": "[String]",
      "defaultValue": ["blue-chip", "top-established", "top-emerging"]
    }, {
      "kind": "LocalArgument",
      "name": "acquireable",
      "type": "Boolean",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "aggregations",
      "type": "[ArtworkAggregation]",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "artist_id",
      "type": "String",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "at_auction",
      "type": "Boolean",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "attribution_class",
      "type": "[String]",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "color",
      "type": "String",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "for_sale",
      "type": "Boolean",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "hasFilter",
      "type": "Boolean",
      "defaultValue": false
    }, {
      "kind": "LocalArgument",
      "name": "height",
      "type": "String",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "inquireable_only",
      "type": "Boolean",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "keyword",
      "type": "String",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "major_periods",
      "type": "[String]",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "medium",
      "type": "String",
      "defaultValue": "*"
    }, {
      "kind": "LocalArgument",
      "name": "offerable",
      "type": "Boolean",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "page",
      "type": "Int",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "partner_id",
      "type": "ID",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "price_range",
      "type": "String",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "sort",
      "type": "String",
      "defaultValue": "-partner_updated_at"
    }, {
      "kind": "LocalArgument",
      "name": "width",
      "type": "String",
      "defaultValue": null
    }],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "biography_blurb",
      "storageKey": "biography_blurb(format:\"HTML\",partner_bio:true)",
      "args": [{
        "kind": "Literal",
        "name": "format",
        "value": "HTML",
        "type": "Format"
      }, {
        "kind": "Literal",
        "name": "partner_bio",
        "value": true,
        "type": "Boolean"
      }],
      "concreteType": "ArtistBlurb",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "text",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "credit",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "FragmentSpread",
      "name": "ArtistBio_bio",
      "args": null
    }, {
      "kind": "FragmentSpread",
      "name": "MarketInsights_artist",
      "args": null
    }, {
      "kind": "FragmentSpread",
      "name": "SelectedCareerAchievements_artist",
      "args": null
    }, {
      "kind": "FragmentSpread",
      "name": "Genes_artist",
      "args": null
    }, {
      "kind": "FragmentSpread",
      "name": "FollowArtistButton_artist",
      "args": null
    }, v0, {
      "kind": "LinkedField",
      "alias": null,
      "name": "counts",
      "storageKey": null,
      "args": null,
      "concreteType": "ArtistCounts",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "partner_shows",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "for_sale_artworks",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "ecommerce_artworks",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "auction_artworks",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "artworks",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "has_make_offer_artworks",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "href",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "is_consignable",
      "args": null,
      "storageKey": null
    }, {
      "kind": "FragmentSpread",
      "name": "CurrentEvent_artist",
      "args": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "currentEvent",
      "storageKey": null,
      "args": null,
      "concreteType": "CurrentEvent",
      "plural": false,
      "selections": [v1]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "related",
      "storageKey": null,
      "args": null,
      "concreteType": "ArtistRelatedData",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "genes",
        "storageKey": null,
        "args": null,
        "concreteType": "GeneConnection",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "GeneEdge",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Gene",
            "plural": false,
            "selections": v3
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "artists",
        "storageKey": "artists(first:1)",
        "args": [{
          "kind": "Literal",
          "name": "first",
          "value": 1,
          "type": "Int"
        }],
        "concreteType": "ArtistConnection",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ArtistEdge",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Artist",
            "plural": false,
            "selections": [v2]
          }]
        }]
      }]
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "_id",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "collections",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "highlights",
      "storageKey": null,
      "args": null,
      "concreteType": "ArtistHighlights",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "partners",
        "storageKey": null,
        "args": [{
          "kind": "Literal",
          "name": "display_on_partner_profile",
          "value": true,
          "type": "Boolean"
        }, {
          "kind": "Literal",
          "name": "first",
          "value": 10,
          "type": "Int"
        }, {
          "kind": "Variable",
          "name": "partner_category",
          "variableName": "partner_category",
          "type": "[String]"
        }, {
          "kind": "Literal",
          "name": "represented_by",
          "value": true,
          "type": "Boolean"
        }],
        "concreteType": "PartnerArtistConnection",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "PartnerArtistEdge",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Partner",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "categories",
              "storageKey": null,
              "args": null,
              "concreteType": "Category",
              "plural": true,
              "selections": v3
            }, v2]
          }, v2]
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "insights",
      "storageKey": null,
      "args": null,
      "concreteType": "ArtistInsight",
      "plural": true,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "type",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "LinkedField",
      "alias": "sidebarAggregations",
      "name": "filtered_artworks",
      "storageKey": null,
      "args": [{
        "kind": "Variable",
        "name": "aggregations",
        "variableName": "aggregations",
        "type": "[ArtworkAggregation]"
      }, {
        "kind": "Variable",
        "name": "page",
        "variableName": "page",
        "type": "Int"
      }, {
        "kind": "Variable",
        "name": "sort",
        "variableName": "sort",
        "type": "String"
      }],
      "concreteType": "FilterArtworks",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "aggregations",
        "storageKey": null,
        "args": null,
        "concreteType": "ArtworksAggregationResults",
        "plural": true,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "slice",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "counts",
          "storageKey": null,
          "args": null,
          "concreteType": "AggregationCount",
          "plural": true,
          "selections": [v1, v0, v2]
        }]
      }, v2, {
        "kind": "Condition",
        "passingValue": false,
        "condition": "hasFilter",
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "artworks_connection",
          "storageKey": "artworks_connection(after:\"\",first:30)",
          "args": [{
            "kind": "Literal",
            "name": "after",
            "value": "",
            "type": "String"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 30,
            "type": "Int"
          }],
          "concreteType": "ArtworkConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "ArtworkEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Artwork",
              "plural": false,
              "selections": v3
            }]
          }]
        }]
      }]
    }, {
      "kind": "FragmentSpread",
      "name": "ArtistArtworkFilter_artist",
      "args": [{
        "kind": "Variable",
        "name": "acquireable",
        "variableName": "acquireable",
        "type": null
      }, {
        "kind": "Variable",
        "name": "aggregations",
        "variableName": "aggregations",
        "type": null
      }, {
        "kind": "Variable",
        "name": "artist_id",
        "variableName": "artist_id",
        "type": null
      }, {
        "kind": "Variable",
        "name": "at_auction",
        "variableName": "at_auction",
        "type": null
      }, {
        "kind": "Variable",
        "name": "attribution_class",
        "variableName": "attribution_class",
        "type": null
      }, {
        "kind": "Variable",
        "name": "color",
        "variableName": "color",
        "type": null
      }, {
        "kind": "Variable",
        "name": "for_sale",
        "variableName": "for_sale",
        "type": null
      }, {
        "kind": "Variable",
        "name": "hasFilter",
        "variableName": "hasFilter",
        "type": null
      }, {
        "kind": "Variable",
        "name": "height",
        "variableName": "height",
        "type": null
      }, {
        "kind": "Variable",
        "name": "inquireable_only",
        "variableName": "inquireable_only",
        "type": null
      }, {
        "kind": "Variable",
        "name": "keyword",
        "variableName": "keyword",
        "type": null
      }, {
        "kind": "Variable",
        "name": "major_periods",
        "variableName": "major_periods",
        "type": null
      }, {
        "kind": "Variable",
        "name": "medium",
        "variableName": "medium",
        "type": null
      }, {
        "kind": "Variable",
        "name": "offerable",
        "variableName": "offerable",
        "type": null
      }, {
        "kind": "Variable",
        "name": "page",
        "variableName": "page",
        "type": null
      }, {
        "kind": "Variable",
        "name": "partner_id",
        "variableName": "partner_id",
        "type": null
      }, {
        "kind": "Variable",
        "name": "price_range",
        "variableName": "price_range",
        "type": null
      }, {
        "kind": "Variable",
        "name": "sort",
        "variableName": "sort",
        "type": null
      }, {
        "kind": "Variable",
        "name": "width",
        "variableName": "width",
        "type": null
      }]
    }, v2]
  };
}();

node.hash = '13e47b28110b3e96d655a0ac73b9024b';
var _default = node;
exports.default = _default;
//# sourceMappingURL=Overview_artist.graphql.js.map